import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('constant-set');

app.factory('ConstantSet', resource);
